module.exports = __webpack_public_path__ + "static/media/Kolohaus_Logo-05.334d6d6a.png";